import React from 'react'
import './QuestionTitle.scss'
const QuestionTitle = ({ title }) => <h2 className="tetle-item">{title}</h2>

export default QuestionTitle



// WEBPACK FOOTER //
// ./src/modules/Games/Componetns/QuestionTitle/QuestionTitle.js